<script lang="ts">
  import { goto } from "$app/navigation";
  import { page } from "$app/stores";
  import PageWrapper from "$components/+layout/PageWrapper.svelte";
  import Button from "$components/+blocks/Button/Button.svelte";
  import { homeUrl } from "$utils/urls";
  import { Left } from "$components/+blocks/OVIcon";
</script>

<PageWrapper>
  <div class="mt-32 flex w-full flex-col items-center gap-8">
    {#if $page.status}
      <div class="text-3xl font-medium text-gray-600 dark:text-gray-200">{$page.status}</div>
    {/if}
    <div class="text-sm font-normal text-gray-500 dark:text-gray-400">
      {$page.error?.message || "Oh no, something went wrong, please try again"}
    </div>

    <Button variant="primary" label="Go back" on:click={() => goto(homeUrl())} iconLeft={Left} />
  </div>
</PageWrapper>
